import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { postAuthLogout } from '@entities/auth'
import { CfdPush } from '@features/push'
import { clearAuthState } from './authSession'

export const useLogout = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { mutate: logout, isPending } = useMutation({
    mutationFn: async () => {
      await CfdPush.clearSession()
      return postAuthLogout()
    },
    onSettled: () => {
      clearAuthState({ clearPushSession: false })
      queryClient.clear()
      navigate('/login')
    },
  })

  return { logout, isPending }
}
